export default __webpack_public_path__ + "static/media/28t.0bb17242.jpg";